export default {
  // ========== Encabezado ==========
  pda: "PDA",
  suitcase: "Maleta",
  didactic: "Didáctica",
  classroomDidacticPlanSynthesis: "Síntesis Plan Didáctico de Aula",

  // ========== Sección 1: Información General ==========
  generalInformation: "Información General",
  careers: "Carrera/s",
  prerequisites: "Prerrequisitos",

  // ========== Sección 2: Descripción de la Asignatura ==========
  subjectDescription: "Descripción de la Asignatura",
  noDescriptionForEntity: "No hay descripción para {entity}.",
  noEntityForSubject: "No hay {entity1} para {entity2}.",

  // ========== Competencias y Resultados de Aprendizaje ==========
  learningResults: "Resultados de Aprendizaje",
  learningResult: "Resultado de Aprendizaje",
  achievementIndicator: "Indicador de Logro",

  // ========== Sección 3: Síntesis de la Ruta de Aprendizaje ==========
  learningRouteSynthesis: "Síntesis de la Ruta de Aprendizaje",
  learningExperience: "Experiencia de Aprendizaje",
  activitiesAndEvaluations: "Actividades y Evaluaciones",
  learningEnvironments: "Ambientes de Aprendizaje",
  hoursCount: "N° Horas",
  activityAssociatedToVcm: "Actividad Asociada a VCM",
  total: "Total",
  noLearningRouteSynthesis: "No hay {entity}.",

  // ========== Sección 4: Evaluaciones ==========
  evaluations: "Evaluaciones",
  evaluation: "Evaluación",
  evaluativeSituation: "Situación Evaluativa",
  partialEvaluationWeight: "Peso de la Evaluación Parcial (%)",
  finalWeightingEvaluations: "Ponderación Final Evaluaciones",
  noPartialEvaluations: "No hay Evaluaciones Parciales.",

  // ========== Sección 5: Experiencias de Aprendizaje ==========
  learningExperiences: "Experiencias de Aprendizaje",
  activities: "Actividades",
  learningResources: "Recursos de Aprendizaje",
  educationalTechnology: "Tecnología Educativa",
  learningEnvironment: "Ambiente de Aprendizaje",
  noActivitiesInEntity: "No hay actividades en esta {entity}.",
  evaluationType: "Tipo de Evaluación",
  noEvaluationsInEntity: "No hay evaluaciones en esta {entity}.",
  withoutDescription: "Sin Descripción",
}
